export default __webpack_public_path__ + "static/media/ayush-prof.5427cf40.jpg";